import { styled } from 'baseui'

export const GaugeSvg = styled('svg', {
  display: 'block',
  width: '12.5rem',
  maxWidth: '100%',
  height: 'auto',
})
